import { action, observable } from 'mobx'
import api from 'src/common/api'
import { Request3 } from 'src/common/Request3'
import { responseDefault } from './store.constants'
import { LIST_ORDER_STATUS, PAGE_SIZE } from 'src/helpers/constants'
import { find, isEmpty } from 'lodash'

export class OrderStore {
   @observable listOrder = { ...responseDefault }
   @observable listRoutes = { ...responseDefault }
   @observable openDropDown = false
   @observable selectedTrip = 1
   @observable openModal: boolean = false
   @observable selectedStatus: number = 0
   @observable idAction: number | null = null
   @observable typeModal: 'cancel' | 'changeStatus' | null = null
   @observable allListOrder = { ...responseDefault }
   @observable selectionId: any = []
   @observable entries: any = []
   @observable selectedCustomer = {}

   @action
   findTripById(id: number) {
      const find = this.listOrder?.rows?.find((element: any) => element.id === id)
      if (!find) return
      return find
   }

   @action
   async getOrders(params: any = {}) {
      const result = await Request3.getWithToken(api.order.getOrders, {
         ...params,
         ...{ limit: PAGE_SIZE }
      })
      console.log('getOrders', result?.data)

      if (!isEmpty(result?.data)) {
         this.listOrder = {
            ...this.listOrder,
            rows: result.data.results || result.data,
            count: result.data.total || result.data.count || (result.data.results || result.data).length
         }

         this.allListOrder = {
            ...this.allListOrder,
            rows: result.data.results || result.data,
            count: result.data.total || result.data.count || (result.data.results || result.data).length
         }
      }
      return result?.data
   }

   @action
   async getRoutes(params: any = {}) {
      const result = await Request3.getWithToken(api.routePrice.getRoute, {
         ...params,
         limit: PAGE_SIZE
      })
      console.log('getRoutes', result?.data)

      if (!isEmpty(result?.data)) {
         this.listRoutes = {
            rows: result.data,
            limit: PAGE_SIZE,
            offset: 0,
            count: result.data.length
         }
      }
   }

   @action
   async createOrder(params: any = {}) {
      console.log(params)

      const result = await Request3.postWithToken(api.order.create, params)
      console.log('createOrder:', result)
      return result?.data
   }

   @action
   async updateOrder(params: any = {}, id: number) {
      const result = await Request3.patchWithToken(`${api.order.update}/${id}`, params)
      console.log('updateOrder:', result?.data)
      return result?.data
   }

   @action
   async getTripDetail(id: string) {
      const result = await Request3.getWithToken(`${api.order.getOrders}/${id}`)
      return result
   }

   @action
   async deleteTrip(id: number) {
      const result = await Request3.deleteWithToken(`${api.order.delete}/${id}`, {})
      console.log(result?.data)

      this.listOrder = {
         ...this.listOrder,
         rows: this.listOrder.rows.filter((item: any) => item.id !== id)
      }
      this.allListOrder = {
         ...this.listOrder,
         rows: this.listOrder.rows.filter((item: any) => item.id !== id)
      }
      return result
   }

   @action
   async changeStatusTrip(id: number) {
      const trip: any = this.findTripById(id)
      if (trip) {
         const body = {
            routeId: trip.routeId,
            pickupLocationAddress: trip.pickupLocationAddress,
            dropoffLocationAddress: trip.dropoffLocationAddress,
            departureDateTime: trip.departureDateTime,
            orderType: trip.orderType,
            tripDirection: trip.tripDirection,
            receiverName: trip.receiverName,
            receiverPhone: trip.receiverPhone,
            status: this.selectedStatus
         }
         const result = await Request3.patchWithToken(`${api.order.update}/${id}`, body)
         console.log('Change Status : ', result?.data)
         // this.listOrder = {
         //    ...this.listOrder,
         //    rows: this.listOrder.rows.map((item: any) =>
         //       item.id === id ? { ...item, status: this.selectedStatus } : item
         //    )
         // }
      }
   }

   @action
   async cancelTrip(id: number, cancelReason: string | null) {
      const result = await Request3.patchWithToken(`${api.order.cancel.replace(':id', id.toString())}`, {
         cancelReason: cancelReason
      })
      return result?.data
   }

   @action
   async completeTrip(id: number) {
      const result = await Request3.patchWithToken(`${api.order.update}/${id}`, { status: 4 })
      return result?.data
      // this.listOrder = {
      //    ...this.listOrder,
      //    rows: this.listOrder.rows.map((item: any) =>
      //       item.id === id ? { ...item, status: 5} : item
      //    )
      // }
   }

   @action
   getDetailTripType = (value: number): number => {
      return value === 2 || value === 3 ? 1 : value === 1 || value === 4 || value === 5 ? 0 : 2
   }

   @action
   renderOrderType = (orderType: number): string => {
      switch (orderType) {
         case 1:
            return `Xe ghép`
         case 2:
            return `Bao xe 5 chỗ`
         case 3:
            return `Bao xe 7 chỗ`
         case 4:
            return `Khứ hồi 5 chỗ`
         case 5:
            return `Khứ hồi 7 chỗ`
         case 6:
            return `Gửi hàng to`
         case 7:
            return `Gửi hàng nhỏ`

         default:
            return '-'
      }
   }

   @action
   totalPrice = (routeId: number, orderType: number) => {
      const route = this.listRoutes.rows.find((r: any) => r.id === routeId)
      if (route) {
         switch (orderType) {
            case 1:
               return `${(route as any).priceGhep1.toLocaleString('vi', { style: 'currency', currency: 'VND' })}`

            case 2:
               return `${(route as any).priceBaoXe5.toLocaleString('vi', { style: 'currency', currency: 'VND' })}`

            case 3:
               return `${(route as any).priceBaoXe7.toLocaleString('vi', { style: 'currency', currency: 'VND' })}`

            case 4:
               return `${(route as any).priceKhBaoXe5.toLocaleString('vi', { style: 'currency', currency: 'VND' })}`

            case 5:
               return `${(route as any).priceKhBaoXe7.toLocaleString('vi', { style: 'currency', currency: 'VND' })}`

            case 6:
               return `${(route as any).priceHangTo.toLocaleString('vi', { style: 'currency', currency: 'VND' })}`

            case 7:
               return `${(route as any).priceHangNho.toLocaleString('vi', { style: 'currency', currency: 'VND' })}`
         }
      }
   }

   @action
   getRouteName = (routeId: number) => {
      const route = this.listRoutes.rows.find((r: any) => r.id === routeId)
      if (route) {
         return `${(route as any).fromDistrict?.name} - ${(route as any).toDistrict?.name}`
      }
      return '-'
   }

   @action
   renderStatus = (status: number) => {
      return find(LIST_ORDER_STATUS, { value: status })?.label || 'Unknown'
   }

   @action
   driverOptions(listEmployee: any[]) {
      const filtered = listEmployee.filter((element: any) => element.role === 'driver')
      const options = filtered.map((element: any) => ({
         value: element.id,
         label: element.name
      }))
      return options
   }

   @action
   routerOptions() {
      const options = this.listRoutes.rows.map((element: any) => ({
         value: element.id,
         label: `${element.fromDistrict.name} - ${element.toDistrict.name}`
      }))
      return options
   }
}
